// Internal core for Modal and Drawer. Not exported from the kit barrel.

export { DialogHeader } from "./DialogHeader";
export { DialogRoot } from "./DialogRoot";
export { DialogBody, DialogFooter } from "./DialogSections";

/** Below this width a Drawer, and a Modal by default, become a bottom sheet. */
export const MOBILE_QUERY = "(max-width: 639px)";
